export default __webpack_public_path__ + "static/media/EM1280.34I-39724_-23573_0.3857f0b1.jpg";